/********** Art Box **********/
  /***** adobefont *****/
    (function(d) {
      var config = {
        kitId: 'wqa4aqs',
        scriptTimeout: 3000,
        async: true
      },
      h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);
  /***** /adobefont *****/

  /***** drawer *****/
    $(document).ready(function() {
      $('button.drawer_open').on('click', function(){
        $('nav#drawer').removeClass('drawer_hide').addClass('drawer_show');
        $('main#MainContent > div:not(:eq(0))').animate({ opacity: 0 }, { duration: 400, easing: 'swing'});
      });
    });

    $(document).ready(function() {
      $('button.drawer_close').on('click', function(){
        $('nav#drawer').removeClass('drawer_show').addClass('drawer_hide');
        $('main#MainContent > div:not(:eq(0))').animate({ opacity: 1 }, { duration: 600, easing: 'swing'});
      });
    });
  /***** /drawer *****/

  /***** MainContent addclass *****/
    $(document).ready(function(){
      $('.shopify-section[id$="__16633196759b03184c"],.shopify-section[id$="__1663319943a8052567"],.shopify-section[id$="__166417182715f969ee"],.shopify-section[id$="__166424610136094a2c"],.shopify-section[id$="__16644387473fb81dbf"],.shopify-section[id$="__166443196884a30266"],.shopify-section[id$="__1664438764007a6879"],.shopify-section[id$="__1664431983f58b0324"],.shopify-section[id$="__1a6bad17-4334-4b51-8f29-2e6064c1b422"],.shopify-section[id$="__43bacfe2-727a-42ea-ac3f-9f30c885f871"],.shopify-section[id$="__235a697c-65e5-4443-83bb-7e7c33454fb9"],.shopify-section[id$="__14b9a414-1e3f-4098-ab06-29a1b488b343"]').addClass('skmtcnt');
    });

    $(document).ready(function(){
      $('.shopify-section[id$="__16633196759b03184c"],.shopify-section[id$="__1663319943a8052567"],.shopify-section[id$="__166417182715f969ee"],.shopify-section[id$="__166424610136094a2c"],.shopify-section[id$="__16644387473fb81dbf"],.shopify-section[id$="__166443196884a30266"],.shopify-section[id$="__1664438764007a6879"],.shopify-section[id$="__1664431983f58b0324"],.shopify-section[id$="__1a6bad17-4334-4b51-8f29-2e6064c1b422"],.shopify-section[id$="__43bacfe2-727a-42ea-ac3f-9f30c885f871"],.shopify-section[id$="__235a697c-65e5-4443-83bb-7e7c33454fb9"],.shopify-section[id$="__14b9a414-1e3f-4098-ab06-29a1b488b343"]').addClass('skmtcnt');
    });

    /* ghead */
      $(document).ready(function(){
        $('.shopify-section[id$="__16633196759b03184c"],.shopify-section[id$="__166443196884a30266"],.shopify-section[id$="__1a6bad17-4334-4b51-8f29-2e6064c1b422"],.shopify-section[id$="__597608ec-bb9c-4afd-85b5-d09e04f34fb0"]').addClass('skmt_ghead');
      });
    /* ghead */

    /* hero */
      $(document).ready(function(){
        $('.shopify-section[id$="__73b57f51-d278-49f8-bd9d-9b8a302b36ef"],.shopify-section[id$="__1663319943a8052567"],.shopify-section[id$="__16644387473fb81dbf"],.shopify-section[id$="__43bacfe2-727a-42ea-ac3f-9f30c885f871"],.shopify-section[id$="__a4fe876a-37cf-4d8d-bca9-7f7fa8c3e087"],.shopify-section[id$="__1c04c170-5855-4273-b671-71988f49c635"]').addClass('skmt_hero');
      });

      $(document).ready(function(){
        $('.shopify-section[id$="__73b57f51-d278-49f8-bd9d-9b8a302b36ef"]').addClass('skmt_hero_top');
      });

      $(document).ready(function(){
        $("#shopify-section-template--14828042846291__a4fe876a-37cf-4d8d-bca9-7f7fa8c3e087").addClass('skmt_hero_detail');
      });

      $(document).ready(function(){
        $('.shopify-section[id$="__1c04c170-5855-4273-b671-71988f49c635"]').addClass('skmt_hero_mapandnews');
      });
    /* /hero */

    /* content */
      $(document).ready(function(){
        $('.shopify-section[id$="__166417182715f969ee"],.shopify-section[id$="__1664438764007a6879"],.shopify-section[id$="__235a697c-65e5-4443-83bb-7e7c33454fb9"],.shopify-section[id$="__badbc88d-8bd4-4777-b155-a5810107e9d9"]').addClass('skmt_cnt');
      });

      $(document).ready(function(){
        $('.shopify-section[id$="__166417182715f969ee"]').addClass('skmt_cnt_top');
      });

      /* page_content */
        $(document).ready(function(){
          $('.shopify-section[id$="__main"]').addClass('skmt_page_cnt');
        });
      /* /page_content */
    /* /content */

    /* gfoot */
      $(document).ready(function(){
        $('.shopify-section[id$="__166424610136094a2c"],.shopify-section[id$="__1664431983f58b0324"],.shopify-section[id$="__14b9a414-1e3f-4098-ab06-29a1b488b343"],.shopify-section[id$="__e9d7d25e-4e05-4c0d-929f-90b45295ddc9"]').addClass('skmt_gfoot');
      });
    /* /gfoot */
  /***** /MainContent addclass *****/

  /***** delay load *****/
    $(function() {
      // $('main#MainContent').css({'display': 'none'});
      $('main#MainContent header').fadeIn(1000);
      $('main#MainContent > div.skmt_hero_top > div div.hero__text-shadow > h2 > div > img').fadeIn(1000);
      $('main#MainContent > div.skmt_cnt_top ul').fadeIn(1000);
      $('main#MainContent footer').fadeIn(1000);
      // $('main#MainContent').css({'visibility': 'visible'});
    });
  /***** /delay load *****/

  /***** anchor *****/
      $(function () {
          // var headH = $('header').outerHeight();
          // var navH = $('nav').outerHeight();
          // var sclH = headH + navH;
          var animeSpeed = 500;
          $("a[href^='#']").on({
              "click": function () {
                  var href = $(this).attr('href');
                  var target = $(href == "#" || href === "" ? "html" : href);
                  var position;
                  position = target.offset().top - 100;
                  $("body,html").stop().animate({
                      scrollTop: position
                  }, animeSpeed);
                  return false;
              }
          });
      });
  /***** /anchor *****/

  /***** newsmoretext *****/
    jQuery(function($){
      $('.shownews').click(function(){
        $(this).next('.acl').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        // $(this).addClass('hide');
        return false;
      });
    });
    /* jQuery(function($){
      $('.hidetxt').click(function(){
        $.when(
          $('.more').addClass('hide txtfadeOut')
        ).done(function(){ 
          setTimeout(function() {
            $('.more').removeClass('show txtfadeIn');
          }, 500);
        });
        $('.showtxt').removeClass('hide');
        return false;
      });
    }); */
  /***** /newsmoretext *****/

  /***** newslistmoretext *****/
    jQuery(function($){
      $('section#news dt.showtxt').click(function(){
        $('section#news .more').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        $(this).addClass('hide');
        return false;
      });
    });
    jQuery(function($){
      $('section#topics dt.showtxt').click(function(){
        $('section#topics .more').removeClass('hide txtfadeOut').addClass('show txtfadeIn');
        $(this).addClass('hide');
        return false;
      });
    });
    /* jQuery(function($){
      $('.hidetxt').click(function(){
        $.when(
          $('.more').addClass('hide txtfadeOut')
        ).done(function(){ 
          setTimeout(function() {
            $('.more').removeClass('show txtfadeIn');
          }, 500);
        });
        $('.showtxt').removeClass('hide');
        return false;
      });
    }); */
  /***** /newslistmoretext *****/

  /***** a no link *****/
      $(function(){
          $('a.nolink').on('click', function() {
            return false;
          });
      });
  /***** /a no link *****/

  /***** timer *****/
    $(document).ready(function() {
     $(".view_timer").each(function(index, target) {
       var startDate = $(this).attr("data-startdate");
       var endDate = $(this).attr("data-enddate");
       var nowDate = new Date();
       if (startDate) {
         startDate = new Date(startDate);
       } else {
         startDate = nowDate;
       }
       if (endDate) {
         endDate = new Date(endDate);
       }
       if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
         $(this).addClass('new');
       } else {
         $(this).removeClass('new');
       }
     });
    });

    $(document).ready(function() {
     $(".show_timer").each(function(index, target) {
       var startDate = $(this).attr("data-startdate");
       var endDate = $(this).attr("data-enddate");
       var nowDate = new Date();
       if (startDate) {
         startDate = new Date(startDate);
       } else {
         startDate = nowDate;
       }
       if (endDate) {
         endDate = new Date(endDate);
       }
       if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
         $(this).show();
       } else {
         $(this).hide();
       }
     });
    });
  /***** /timer *****/

  /***** slick *****/
    $(document).ready(function(){
      $('.itemSlider').slick({
        arrows: false,
        // centerMode: true,
        // centerPadding: '18%',
        cssEase: 'ease',
        dots: true,
        dotsClass: 'dotPaging',
        fade: true,
        pauseOnDotsHover: true,
        // autoplay: false,
        autoplay: true,
        // 自動再生で切り替えをする時間
        autoplaySpeed: 5000,
        // 自動再生や左右の矢印でスライドするスピード
        speed: 4000,
        // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,

        /* responsive: [
          {
            breakpoint: 812,
            settings: {
              centerMode: true,
              centerPadding: '15%'
            }
          }
        ] */

      });
    });
  /***** /slick *****/

  /***** modal *****/
    $(function(){
      var modal = $('.modalimg li');
      modal.on('click', function(){
        var src = $(this).children('img').prop('src');
        var tarr = src.split('/');
        var file = tarr[tarr.length-1];
        var imgPath = file.split('.')[0];
        $('#over').fadeIn(500);
        $('#modal').fadeIn(1000).html('<img src="https://cdn.shopify.com/s/files/1/0549/4879/0355/files/'+imgPath+'_2.jpg" alt=""><i id="close">×</i>');
        $('#modal').on('click', function(){
          return false;
        });
        $('#over, #close').on('click', function(){
          $('#over').fadeOut(500);
          $('#modal').fadeOut(100);
        });
      });
    });
  /***** /modal *****/

  /***** ua *****/
    if (navigator.userAgent.indexOf('iPhone') > 0) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add('iPhone');
    }
     
    if (navigator.userAgent.indexOf('iPad') > 0) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add('iPad');
    }
     
    if (navigator.userAgent.indexOf('Android') > 0) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add('Android');
    }
  /***** /ua *****/

  /***** drift *****/
    new Drift(document.querySelector('.mapimg'), {
      paneContainer: document.querySelector('.mapzoom'),
      zoomFactor: 6,
      inlinePane: false,
    });

    /* var demoTrigger = document.querySelector('.mapimg');
    var paneContainer = document.querySelector('.mapzoom');

    new Drift(demoTrigger, {
      paneContainer: paneContainer,
      inlinePane: false,
    }); */

      $(function() {
        $('div.map > figure')
          .mouseover(function(e) {
            $(this).addClass('rotatepaused');
            // $('div.mapzoom').addClass('rotatepaused');
          })
          .mouseout(function(e) {
            $(this).removeClass('rotatepaused');
            // $('div.mapzoom').removeClass('rotatepaused');
          });
      });

      $(function() {
        var isDrag = false;
        $("div.map > figure").on('touchmove', function (e) {
            if(!isDrag){
              $(this).addClass('rotatepaused');
              // $('div.mapzoom').addClass('rotatepaused');
            }
        });
        $("div.map > figure").on('touchend', function (e) {
            if(!isDrag){
              $(this).removeClass('rotatepaused');
              // $('div.mapzoom').removeClass('rotatepaused');
            }
            isDrag = false;
        });
      });
  /***** /drift *****/
/********** /Art Box **********/